import { Component, OnInit, Input } from '@angular/core';
import { LegendPosition } from '@swimlane/ngx-charts';
import { ReportMetadata } from '../../models/report.model';

@Component({
  selector: 'app-report-graph',
  templateUrl: './report-graph.component.html',
  styleUrls: ['./report-graph.component.scss']
})
export class ReportGraphComponent implements OnInit {

  @Input() reportMetadata: ReportMetadata;
  @Input() graphData: any[];

  readonly LegendPosition = LegendPosition;

  constructor() { }

  ngOnInit(): void {
  }

}
